import "@testing-library/jest-dom";
import { fireEvent, render, screen } from "@testing-library/react";
import { RelatedRecordsProperties } from "./RelatedRecordsProperties";
const sources = [
  {
    id: "people",
    name: "Employees",
    type: "view" as const,
    view_id: "employee-view",
    config: {},
  },
  {
    id: "assignments",
    name: "Assignments",
    type: "view" as const,
    view_id: "assignment-view",
    config: {},
  },
];
test("builder config edits the relationship and bounded page size without losing fields", () => {
  const update = jest.fn();
  render(
    <RelatedRecordsProperties
      props={{
        data_source_alias: "people",
        related_records_config: {
          related_data_source_alias: "assignments",
          relationship_path: "jobs",
          display_fields: ["title"],
          max_records: 25,
        },
      }}
      dataSources={sources}
      onChange={update}
    />,
  );
  fireEvent.change(screen.getByLabelText("Relationship path"), {
    target: { value: "assignments" },
  });
  expect(update).toHaveBeenCalledWith({
    related_records_config: {
      related_data_source_alias: "assignments",
      relationship_path: "assignments",
      display_fields: ["title"],
      max_records: 25,
    },
  });
  fireEvent.change(screen.getByLabelText("Records per page"), {
    target: { value: "50" },
  });
  expect(update).toHaveBeenLastCalledWith(
    expect.objectContaining({
      related_records_config: expect.objectContaining({ max_records: 50 }),
    }),
  );
});
test("edit flag is explicit and detail navigation uses the selected related row", () => {
  const update = jest.fn();
  render(
    <RelatedRecordsProperties
      props={{ related_records_config: { display_fields: ["title"] } }}
      dataSources={sources}
      onChange={update}
    />,
  );
  fireEvent.click(screen.getByLabelText("Allow editing related records"));
  expect(update).toHaveBeenCalledWith({
    related_records_config: { display_fields: ["title"], allow_edit: true },
  });
  fireEvent.change(screen.getByLabelText("Detail canvas ID (optional)"), {
    target: { value: "detail-canvas" },
  });
  expect(update).toHaveBeenLastCalledWith({
    row_click_action: {
      type: "NAVIGATE",
      config: {
        target_canvas_id: "detail-canvas",
        record_source: "selected",
        return_to_source: true,
      },
    },
  });
});
